module.exports = __webpack_public_path__ + "static/media/DataSource_Icon.5ff50d42.svg";